import isOnSale from './isOnSale'

const finalPrice = product => {
  if (isOnSale(product)) {
    return product.special_price
  }
  return product?.price ?? product?.final_price
}

export default finalPrice
